import {InfoEntry, TFaqSection, TMetaData} from '.'

const MetaData: TMetaData = {
  title: 'Juegos Gratis Online para Jugar Ahora sin Descargar | Gamezop',
  desc: 'Juegos gratis online para jugar ahora sin descargar en Gamezop. ¡Más de 200 juegos online gratis en español, incluyendo acción, aventura, arcade, puzzles, carreras y mucho más! ¡Empieza a jugar ahora!',
}

const InfoData: InfoEntry[] = [
  {
    tag: 'h1',
    title: 'Juegos Gratis Online para Jugar Ahora sin Descargar',
    body: {
      text: [
        `¡Juega gratis en Gamezop sin necesidad de descargar!
          Elige tu juego favorito de nuestra lista y empieza a jugar en segundos. Tenemos más de 200 juegos gratis en categorías como acción, aventura, arcade, rompecabezas, carreras y más. Ya sea que juegues en móvil, PC o iOS, en Gamezop encontrarás los mejores juegos para ti.`,
        `Si estás aburrido, Gamezop tiene infinitas opciones para entretenerte. Construye defensas para detener a los enemigos, dispara a los objetivos o salta obstáculos. Disfruta de juegos emocionantes como Kingdom Fight, City Cricket, Fruity Fiesta y muchos más. Nuestros juegos son aptos para todas las edades—niños, adultos y mayores.`,
        `No necesitas un dispositivo de alta gama para jugar. Nuestros juegos funcionan sin instalación ni descargas, solo necesitas un navegador y conexión a Internet. Juega en computadoras de escritorio, portátiles, Chromebooks, teléfonos inteligentes, tabletas y más.`,
      ],
      list: [],
    },
    links: {
      'Kingdom Fight': {
        type: 'game',
        name: 'Kingdom Fight',
        code: 'SyfxJ3a75Cr',
      },
      'City Cricket': {
        type: 'game',
        name: 'City Cricket',
        code: 'HJP4afkvqJQ',
      },
      'Fruity Fiesta': {
        type: 'game',
        name: 'Fruity Fiesta',
        code: 'mKZZW9NXW',
      },
    },
  },
  {
    tag: 'h2',
    title: '¿Cuáles son los mejores juegos online gratis',
    body: {
      text: [],
      list: [
        {
          name: 'Bubble Wipeout',
          code: 'H1AN6fkwqJ7',
          type: 'game',
        },
        {
          name: 'Mahjong At Home: Scandinavian Edition',
          code: 'JVhRZNwly',
          type: 'game',
        },
        {
          name: 'Merge Mania',
          code: 'hfPOimYqY',
          type: 'game',
        },
        {
          name: 'Chef Tycoon',
          code: 'xqO4nZ6Kt',
          type: 'game',
        },
        {
          name: 'Cyberfusion',
          code: 'HJXei0j',
          type: 'game',
        },
        {
          name: 'Mafia Billiard Tricks',
          code: 'SkkV6MJD51Q',
          type: 'game',
        },
        {
          name: 'Spider Solitaire',
          code: 'B1MfIa4QCg',
          type: 'game',
        },
        {
          name: 'Basket Champs',
          code: 'S1_V6GyP5ym',
          type: 'game',
        },
        {
          name: 'Algerian Solitaire',
          code: 'rJu76zkD917',
          type: 'game',
        },
        {
          name: 'Dragon Annihilation',
          code: 'PdIZyZNAe',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: '¿Cuáles son los juegos gratis online para jugar con amigos?',
    body: {
      text: [],
      list: [
        {
          name: 'Ludo with Friends',
          code: 'SkhljT2fdgb',
          type: 'game',
        },
        {
          name: 'ZUNO',
          code: 'ByQxJnp7qRB',
          type: 'game',
        },
        {
          name: 'Tic Tac Toe',
          code: 'H1WmafkP9JQ',
          type: 'game',
        },
        {
          name: 'Ludo Dash',
          code: 'SJRX12TXcRH',
          type: 'game',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: '¿Cuáles son los géneros de juegos online más populares?',
    body: {
      text: [],
      list: [
        {
          name: 'Juegos locos',
          nameEn: 'Crazy games',
          code: '10',
          type: 'tag',
        },
        {
          name: 'Juegos de mesa',
          nameEn: 'Board games',
          code: '11',
          type: 'tag',
        },
        {
          name: 'Juegos de aventura',
          nameEn: 'Adventure games',
          code: '14',
          type: 'tag',
        },
        {
          name: 'Juegos de puzzles',
          nameEn: 'Puzzle games',
          code: '8',
          type: 'tag',
        },
        {
          name: 'Juegos de disparos',
          nameEn: 'Shooting games',
          code: '2',
          type: 'tag',
        },
      ],
    },
    initalState: 'initial_open',
  },
  {
    tag: 'h2',
    title: `¿Qué es Gamezop?`,
    body: {
      text: [
        `Gamezop es una plataforma de juegos plug-and-play que permite a aplicaciones y sitios web integrar juegos casuales de manera sencilla, mejorando significativamente el compromiso de los usuarios. Más allá de los juegos, Gamezop opera varias plataformas especializadas: Quizzop para cuestionarios interactivos y trivia, Astrozop para predicciones y contenido astrológico, Criczop para resultados y actualizaciones de cricket en vivo, y Feedzop para la agregación de noticias seleccionadas. Juntas, estas plataformas ofrecen una solución diversa de contenido que satisface los intereses de diferentes públicos.`,
        `Con más de 8,000 integraciones en más de 70 países, Gamezop y sus plataformas asociadas son respaldadas por marcas globales como Amazon, Samsung Internet, Snap, Tata Play, AccuWeather y Paytm. Estas soluciones no solo impulsan el compromiso de los usuarios, sino que también desbloquean nuevas oportunidades de ingresos. La integración es rápida, tomando solo 30 minutos, y permite a aplicaciones y sitios web ofrecer contenido atractivo que incluye juegos, cuestionarios, astrología, cricket y noticias.`,
      ],
      list: [],
    },
    initalState: 'initial_open',
  },
]

const FaqData: TFaqSection = {
  headTag: 'h2',
  headTitle: 'Preguntas frecuentes',
  faqs: [
    {
      tag: 'h3',
      title: '¿Puedo jugar juegos gratis sin descargar ni instalarlos?',
      body: ['Sí, puedes jugar juegos gratis sin descargarlos ni instalarlos.'],
    },
    {
      tag: 'h3',
      title: '¿Necesito registrarme para jugar?',
      body: [
        'No, no necesitas registrarte para jugar en Gamezop.com. Puedes empezar a jugar al instante sin ningún registro.',
      ],
      links: {
        'Gamezop.com': 'https://www.gamezop.com/es',
      },
    },
    {
      tag: 'h3',
      title: '¿Es seguro jugar juegos online?',
      body: [
        'Sí, es seguro jugar juegos online en plataformas confiables como Gamezop. Nuestros juegos no requieren descargas, lo que minimiza los riesgos de malware. Nos enfocamos en la seguridad del usuario y garantizamos una experiencia de juego segura sin comprometer tu privacidad ni la seguridad de tu dispositivo.',
      ],
    },
    {
      tag: 'h3',
      title: '¿Los juegos gratis son realmente gratis?',
      body: [
        'Sí, los juegos gratis son realmente gratuitos en Gamezop. Sin embargo, estos juegos pueden mostrar anuncios para apoyar la plataforma.',
      ],
    },
    {
      tag: 'h3',
      title: '¿Hay juegos gratis para adultos mayores en línea?',
      body: [
        'Sí, tenemos juegos gratis para adultos mayores que puedes jugar en línea, como Sudoku Classic, Solitaire Gold, Chess Grandmaster y más.',
      ],
      links: {
        'Sudoku Classic': {
          type: 'game',
          name: 'Sudoku Classic',
          code: 'SJgx126Qc0H',
        },
        'Solitaire Gold': {
          type: 'game',
          name: 'Solitaire Gold',
          code: 'rkPlk2T7qAr',
        },
        'Chess Grandmaster': {
          type: 'game',
          name: 'Chess Grandmaster',
          code: 'rkAXTzkD5kX',
        },
      },
    },
  ],
}

export default {
  meta: MetaData,
  info: InfoData,
  faq: FaqData,
}
